import { render, staticRenderFns } from "./VideoAudit.vue?vue&type=template&id=0818f087&scoped=true"
import script from "./VideoAudit.vue?vue&type=script&lang=js"
export * from "./VideoAudit.vue?vue&type=script&lang=js"
import style0 from "./VideoAudit.vue?vue&type=style&index=0&id=0818f087&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0818f087",
  null
  
)

export default component.exports